import { Link } from "react-router-dom";
import { ArrowRight, Home, Building2, Users, Wrench } from "lucide-react";
import { IMG } from "@/lib/site";
import { Reveal, Eyebrow } from "@/components/Reveal";

const CARDS = [
  { icon: Home, t: "Privatumzüge", d: "Wohnung, Haus oder einzelne Räume – vom Packen bis zum Aufbau.", slug: "umzuege" },
  { icon: Building2, t: "Firmenumzüge", d: "Büro, Praxis, Betrieb – geplant außerhalb der Stoßzeiten.", slug: "umzuege" },
  { icon: Users, t: "Umzugshelfer", d: "Erfahrene Hände stundenweise oder für den ganzen Tag.", slug: "umzugshelfer" },
  { icon: Wrench, t: "Möbelmontage", d: "Demontage am Start, Wiederaufbau am Ziel – aus einer Hand.", slug: "moebelmontage" },
];

export const MovingSection = () => (
  <section id="umzuege" data-testid="moving-section" className="relative w-full bg-white text-[#0a0a0a] py-20 sm:py-24 lg:py-32">
    <div className="w-full px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow chapter="03" dark>
            Umzüge
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display uppercase font-black leading-[0.9] tracking-tight text-[clamp(2.1rem,7vw,4.4rem)]">
            Umzüge mit<br />
            <span className="text-[#f95700]">System.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-[15px] sm:text-base text-neutral-600 leading-relaxed max-w-xl">
            Ein Umzug ist mehr als eine Fahrt. Wir klären vorab Etagen, Zugänge und Parksituation,
            bringen Packmaterial mit, sichern Möbel und stellen am Ziel wieder auf. Sie bekommen
            einen festen Ablauf statt eines vagen Versprechens.
          </p>
        </Reveal>
        <Reveal delay={0.14}>
          <a
            href="#konfigurator"
            data-testid="moving-cta-button"
            className="mt-8 group inline-flex items-center gap-4 bg-[#0a0a0a] hover:bg-[#f95700] text-white h-14 px-7 font-display text-base sm:text-lg font-bold uppercase tracking-wide transition-colors"
          >
            Umzug anfragen
            <ArrowRight size={19} className="transition-transform duration-500 group-hover:translate-x-1.5" />
          </a>
        </Reveal>
      </div>

      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-neutral-200">
        <Reveal className="sm:col-span-2 relative overflow-hidden">
          <img src={IMG.moversHome} alt="Umzug mit Global Move Europa" loading="lazy" className="w-full h-56 sm:h-72 object-cover" />
        </Reveal>
        {CARDS.map((c, i) => (
          <Reveal key={c.t} delay={0.05 * i} className="group bg-white p-6 sm:p-7 relative overflow-hidden">
            <span className="absolute top-0 left-0 h-full w-[3px] bg-[#f95700] scale-y-0 origin-top transition-transform duration-500 group-hover:scale-y-100" />
            <c.icon size={22} className="text-[#f95700] mb-4" />
            <h3 className="font-display text-xl font-bold uppercase tracking-tight">{c.t}</h3>
            <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{c.d}</p>
            <Link
              to={`/leistungen/${c.slug}`}
              data-testid={`moving-card-link-${c.slug}`}
              className="mt-4 inline-flex items-center gap-1.5 font-mono-t text-[11px] uppercase tracking-widest text-neutral-500 group-hover:text-[#f95700] transition-colors"
            >
              Mehr erfahren <ArrowRight size={13} />
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
